<template>
  <div class="bg-gray">
    <div class="form-content">

      <el-form
          v-loading="loading"
          :model="row"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="单位名称：">
              <div>{{ row.danwei }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属区域：">
              <div>{{ areaValue }}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="先进个人：">
              <div>{{ row.name }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证书编号：">
              <div>{{ row.bcode ? row.bcode : '无' }}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="推广实施单位电子授权书：">
              <div class="bottom-img" v-show="!isLoading">
                <img :src="row.danwei_pic" alt="">

                <el-button @click="onPrint" style="margin: 10px auto; text-align: center " type="default" round>
                  点击下载证书
                </el-button>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="先进个人电子授权书：">
              <div class="bottom-img" v-show="!isLoading">
                <img :src="row.person_pic" alt="">

                <el-button @click="onPrintPerson" style="margin: 10px auto; text-align: center " type="default" round>
                  点击下载证书
                </el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
      </el-form>

    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
  </div>
  </div>
</template>
<style scoped>
.kaoji-box .van-cell__value {
  color: #323233;
}
.kaoji-title {
  padding: .3rem;
  font-size: 24px;
  text-align: center;
}

.kaoji-mine {
  padding: 0 .3rem .4rem;
}

.bottom-img {
  text-align: center;
  margin-top: .3rem;
}

.bottom-img img {
  width: 100%;
}

.bottom-button {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  margin-right: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import LoginDialog from '@/components/LoginDialog.vue';

import {
  Cell,
  Field,
  Dialog,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Dialog).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'CDakejianDetail',
  components: {
    PicUploader,
    LoginDialog
  },
  data: function () {
    return {
      validator,
      loginShow: false,
      saveLoading: false,
      isLoading: true,
      loading: true,
      showArea: false,
      areaList: {},
      areaValue: '',
      submitType: '',
      id: 0,
      row: {},
      isApp: window.isApp()
    }
  },
  filters: {},
  mounted() {
    let that = this;
    that.id = this.$route.query.id;
    document.title = "大课间详情"
    that.fetch();

  },
  watch: {},
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },
    fetch() {
      let that = this;
      // Toast.loading({
      //   message: '加载中...',
      //   forbidClick: true,
      // });
      that.$api.post('/api/cdakejian/dakejianDetail', {
        id : that.id,
      }, (res) => {
        that.areaValue = res.data.province + ' ' + res.data.city + ' ' + res.data.county
        that.row = res.data;

        that.isLoading = false
        that.loading = false
        Toast.clear()
      }, (res) => {
        that.loading = false
//                    Toast.fail(res.msg);
      })
    },

    // 打印电子授权书
    onPrint() {
      let that = this;
      // console.log('downloadPic');
      appEvent({
        name: 'downloadPic',
        query: {
          filename: that.row.danwei + '推广实施单位电子授权书',
          url:that.row.danwei_pic,
        }
      });
    },
    onPrintPerson() {
      let that = this;
      // console.log('downloadPic');
      appEvent({
        name: 'downloadPic',
        query: {
          filename: that.row.danwei + '先进个人电子授权书',
          url:that.row.person_pic,
        }
      });
    },
    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },

  }
}
</script>



// WEBPACK FOOTER //
// DakejianDetail.vue?3c29e162